<template #content>

    <!-- Boleto -->
    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="codigo_de_barras" v-model="data.codigo_de_barras" class="w-full" disabled />
                        <label for="codigo_de_barras">Código de Barras</label>
                    </FloatLabel>
                    <Button icon="pi pi-copy" severity="primary"
                        @click="copiarCodigo(data.codigo_de_barras)"
                        :disabled="!data.boleto_id" />
                </InputGroup>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="boleto" v-model="data.boleto" class="w-full" disabled />
                        <label for="boleto">Boleto</label>
                    </FloatLabel>
                    <Button icon="pi pi-download" severity="primary"
                        @click="download({ id: data.boleto_id, nome: data.boleto })"
                        :disabled="!data.boleto_id" />
                    <Button icon="pi pi-eye" severity="secondary"
                        @click="visualizar({ id: data.boleto_id, nome: data.boleto })"
                        :disabled="!data.boleto_id"></Button>
                    <Button icon="pi pi-trash" severity="danger" @click="remove(data.boleto_id, 'boleto')"
                        :disabled="!data.boleto_id || readOnly"></Button>
                </InputGroup>
                <div class="text-xs text-right">
                    <template v-if="data.boleto_usuario">
                        {{ data.boleto_usuario }} ({{ dateFormat(data.boleto_date) }})
                    </template>
                </div>
            </div>
        </div>

        <!-- Upload de Arquivo -->
        <Fieldset v-if="!readOnly" legend="Upload de Arquivo">
            <Message severity="info" :closable="false" class="mb-3 w-full">
                Envie o <b>PDF original do boleto</b> (com texto). Boleto <b>escaneado ou em foto</b>?
                Use o <b>Upload IA</b> na listagem de contas — só ele lê imagem.
            </Message>

            <!-- Status da análise IA -->
            <Message v-if="iaStatus === 'analisando'" severity="info" :closable="false" class="mb-3 w-full">
                Analisando PDF com IA... aguarde.
            </Message>
            <Message v-if="iaStatus === 'sucesso'" severity="success" :closable="true" class="mb-3 w-full" @close="iaStatus = null">
                <span v-html="iaMensagemSucesso"></span>
            </Message>
            <Message v-if="iaStatus === 'aviso'" severity="warn" :closable="true" class="mb-3 w-full" @close="iaStatus = null">
                <span v-html="iaMensagemAviso"></span>
            </Message>
            <Message v-if="iaStatus === 'indisponivel'" severity="warn" :closable="true" class="mb-3 w-full" @close="iaStatus = null">
                IA indisponível — preencha os dados manualmente. O upload pode prosseguir.
            </Message>
            <Message v-if="iaStatus === 'erro'" severity="error" :closable="true" class="mb-3 w-full" @close="iaStatus = null">
                {{ iaMensagemErro }}
            </Message>

            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingBoleto || iaStatus === 'analisando'" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogBoleto"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingBoleto"
                                :disabled="iaBloqueiaEnvio"
                                @click="handleUploadBoleto"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogBoleto"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondBoleto"
                        name="arquivo"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="application/pdf"
                        :files="filesBoleto"
                        @updatefiles="onFileUpdateBoleto"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingBoleto || iaStatus === 'analisando'" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                </div>
            </BlockUI>
        </Fieldset>

        <!-- <div class="field mt-4 flex gap-2">
            <div class="w-full">
                <FileUpload ref="upload1" name="arquivo" :url="uploadUrl('boleto')" chooseIcon="pi pi-file-plus"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" accept=".pdf"
                    @upload="onUploaded" @error="onUploadError" :maxFileSize="50000000" :data="uploadData">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>
        </div> -->
    </div>

    <!-- Comprovante -->
    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="comprovante" v-model="data.comprovante" class="w-full" disabled />
                        <label for="comprovante">Comprovante</label>
                    </FloatLabel>
                    <Button icon="pi pi-download" severity="primary"
                        @click="download({ id: data.comprovante_id, nome: LogForm.comprovante })"
                        :disabled="!data.comprovante_id" />
                    <Button icon="pi pi-eye" severity="secondary"
                        @click="visualizar({ id: data.comprovante_id, nome: data.comprovante })"
                        :disabled="!data.comprovante_id"></Button>
                    <Button icon="pi pi-trash" severity="danger" @click="remove(data.comprovante_id, 'comprovante')"
                        :disabled="!data.comprovante_id || readOnly"></Button>
                </InputGroup>
                <div class="text-xs text-right">
                    <template v-if="data.comprovante_usuario">
                        {{ data.comprovante_usuario }} ({{ dateFormat(data.comprovante_date) }})
                    </template>
                </div>
            </div>
        </div>

        <!-- Upload de Arquivo -->
        <Fieldset v-if="!readOnly" legend="Upload de Arquivo">
            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingComprovante" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogComprovante"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingComprovante"
                                @click="handleUploadComprovante"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogComprovante"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondComprovante"
                        name="arquivo"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="application/pdf"
                        :files="filesComprovante"
                        @updatefiles="onFileUpdateComprovante"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingComprovante" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                </div>
            </BlockUI>
        </Fieldset>

        <!-- <div class="field mt-4 flex gap-2">
            <div class="w-full">
                <FileUpload ref="upload2" name="arquivo" :url="uploadUrl('comprovante')" chooseIcon="pi pi-file-plus"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" @upload="onUploaded($event, 'comprovante')"
                    @error="onUploadError" :maxFileSize="50000000">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>
        </div> -->
    </div>
</template>
<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import Fieldset from 'primevue/fieldset';
import Toolbar from 'primevue/toolbar';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

const FilePond = vueFilePond(FilePondPluginFileValidateType)

import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import DatePicker from 'primevue/datepicker';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';
import ScrollPanel from 'primevue/scrollpanel';
import Message from 'primevue/message';


import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import Arquivo from '@/service/arquivo.js';
import Conta from '@/service/conta.js';

import Token from '@/utils/Token';
import File from '@/utils/File';

import LogForm from '@/components/LogForm.vue';

import Moment from 'moment';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        InputNumber,
        InputGroup,
        InputGroupAddon,
        DatePicker,
        Textarea,
        FileUpload,
        ScrollPanel,
        Fieldset,
        Toolbar,
        BlockUI,
        ProgressSpinner,
        FilePond,
        Message,

        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,

        LogForm,
    },
    props: {
        data: {},
        /** Quando true, desabilita uploads, remoções e ações de edição — só permite visualizar/baixar/copiar. */
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['save', 'remove', 'close', 'ia-dados-extraidos'],
    data() {
        return {
            contrato: {},
            form: {},
            errors: {},

            filesBoleto: [],
            isLoadingBoleto: false,

            filesComprovante: [],
            isLoadingComprovante: false,

            // Estado da análise IA do boleto
            // Valores possíveis: null | 'analisando' | 'sucesso' | 'aviso' | 'indisponivel' | 'erro'
            iaStatus: null,
            iaMensagemSucesso: null,
            iaMensagemAviso: null,
            iaMensagemErro: null,
            iaAnaliseOk: false,
        }
    },
    mounted() {
        this.form = {...this.data};
    },
    computed: {
        /**
         * Bloqueia o botão "Enviar" quando a IA detectou erro de validação de linha digitável.
         * Não bloqueia quando a IA está indisponível (soft block) ou ainda não foi acionada.
         */
        iaBloqueiaEnvio() {
            return this.iaStatus === 'erro';
        },
    },
    methods: {
        // Boleto
        onFileUpdateBoleto(files) {
            this.filesBoleto = files.map(file => file.file);
            this.iaStatus = null;
            this.iaAnaliseOk = false;

            if (this.filesBoleto.length > 0) {
                this.analisarBoletoPdfComIa(this.filesBoleto[0]);
            }
        },
        openFileDialogBoleto() {
            this.$refs.pondBoleto.browse()
        },
        clearFileDialogBoleto() {
            this.filesBoleto = [];
            this.iaStatus = null;
            this.iaAnaliseOk = false;
        },
        async analisarBoletoPdfComIa(arquivo) {
            if (!this.form.contrato_id) {
                return;
            }

            this.iaStatus = 'analisando';

            const formData = new FormData();
            formData.append('arquivo', arquivo);
            formData.append('contrato_id', this.form.contrato_id);

            try {
                const response = await Conta.analisarBoletoPdf(formData);
                const dados = response.data;

                this.iaAnaliseOk = true;
                this.iaStatus = dados.avisos && dados.avisos.length > 0 ? 'aviso' : 'sucesso';

                const partesSucesso = ['Dados extraídos pela IA:'];
                if (dados.valor) {
                    partesSucesso.push(`Valor R$ ${Number(dados.valor).toFixed(2).replace('.', ',')}`);
                }
                if (dados.data_vencimento) {
                    const partes = dados.data_vencimento.split('-');
                    if (partes.length === 3) {
                        partesSucesso.push(`Vencimento ${partes[2]}/${partes[1]}/${partes[0]}`);
                    }
                }
                if (dados.beneficiario) {
                    partesSucesso.push(`Beneficiário: ${dados.beneficiario}`);
                }

                this.iaMensagemSucesso = partesSucesso.join(' &mdash; ');

                if (dados.avisos && dados.avisos.length > 0) {
                    this.iaMensagemAviso = dados.avisos.join('<br>');
                }

                this.$emit('ia-dados-extraidos', {
                    valor:          dados.valor ?? null,
                    data_vencimento: dados.data_vencimento ?? null,
                    codigo_de_barras: dados.codigo_de_barras ?? null,
                    beneficiario:   dados.beneficiario ?? null,
                    avisos:         dados.avisos ?? [],
                });
            } catch (error) {
                const msg = error.response?.data?.msg;
                const isIaIndisponivel = !error.response || error.response.status >= 500 ||
                    (msg && (
                        msg.toLowerCase().includes('gemini') ||
                        msg.toLowerCase().includes('api key') ||
                        msg.toLowerCase().includes('indisponível') ||
                        msg.toLowerCase().includes('timeout')
                    ));

                if (isIaIndisponivel) {
                    this.iaStatus = 'indisponivel';
                    this.iaAnaliseOk = true;
                } else {
                    this.iaStatus = 'erro';
                    this.iaMensagemErro = msg || 'Erro ao analisar o boleto com IA.';
                    this.iaAnaliseOk = false;
                }
            }
        },
        async handleUploadBoleto() {
            if (!this.form.contrato_id) {
                this.errors.contrato_id = "Campo obrigatório"
                return
            }

            if (this.filesBoleto.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingBoleto = true

            const formData = new FormData()
            this.filesBoleto.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                // const response = await Arquivo.contaCarne(this.form.contrato_id, formData)
                const response = await Arquivo.contaBoleto(this.data.id, formData)

                this.filesBoleto = []

                const contaResp = response.data?.conta ?? {};
                if (response.data?.aviso) {
                    this.$toast.add({
                        severity: 'info',
                        summary: 'Fatura agrupada',
                        detail: response.data.aviso,
                        life: 12000
                    })
                }
                if (!contaResp.codigo_de_barras) {
                    // Boleto anexado, mas o servidor não leu a linha digitável — típico
                    // de imagem/escaneado (sem camada de texto). Sem código de barras a
                    // conta não entra na remessa. Avisa em vez de fingir sucesso.
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Boleto anexado, mas não foi lido',
                        detail: 'Não conseguimos ler o código de barras automaticamente (o boleto pode ser imagem/escaneado). Envie o PDF original do boleto, com texto, para capturar o código de barras e o CNPJ do beneficiário.',
                        life: 12000
                    })
                } else if (!contaResp.beneficiario_cnpj) {
                    // Código lido, mas sem CNPJ do beneficiário — a remessa cairá no
                    // fallback do CNPJ do provedor. Aviso leve.
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'CNPJ do beneficiário não identificado',
                        detail: 'O código de barras foi lido, mas não encontramos o CNPJ do beneficiário no boleto. Na remessa será usado o CNPJ do provedor (fallback).',
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Sucesso',
                        detail: `Boleto incluído com sucesso.`,
                        life: 3000
                    })
                }

                this.$emit('save', {data: response.data, route: 'boleto'});
            } catch (error) {
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Boleto duplicado',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingBoleto = false
            }
        },

        // Comprovante
        onFileUpdateComprovante(files) {
            this.filesComprovante = files.map(file => file.file)
        },
        openFileDialogComprovante() {
            this.$refs.pondComprovante.browse()
        },
        clearFileDialogComprovante() {
            this.filesComprovante = []
        },
        async handleUploadComprovante() {
            if (!this.form.contrato_id) {
                this.errors.contrato_id = "Campo obrigatório"
                return
            }

            if (this.filesComprovante.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingComprovante = true

            const formData = new FormData()
            this.filesComprovante.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                // const response = await Arquivo.contaCarne(this.form.contrato_id, formData)
                const response = await Arquivo.contaComprovante(this.data.id, formData)

                this.filesComprovante = []

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Comprovante incluído com sucesso.`,
                    life: 3000
                })

                this.$emit('save', {data: response.data, route: 'comprovante'});
            } catch (error) {
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingComprovante = false
            }
        },

        dateFormat(value) {
            if (!value) return;
            return Moment.utc(value).local().format("DD/MM/YYYY HH:mm");
        },
        visualizar(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.openWindow(response);
                });
        },
        download(data) {
            Arquivo.view(data.id, 'download=1')
                .then(response => {
                    File.download(response);
                });
        },
        remove(arquivoID, route = 'boleto') {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Arquivo.delete(arquivoID)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.$emit('remove', route);
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        copiarCodigo(codigo){

            if (!codigo) return;

            try {
                navigator.clipboard.writeText(codigo);
                this.$toast.add({
                    severity: "success",
                    summary: "Copiado!",
                    detail: "Código de Barras copiado para a área de transferência",
                    life: 5000,
                    });
            } catch (error) {
                this.$toast.add({
                    severity: "error",
                    summary: "Erro",
                    detail: "Não foi possível copiar o código",
                    life: 5000,
                    });
            }
        },

    }
}
</script>
